"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CooperationAgreementStatus = void 0;
var CooperationAgreementStatus;
(function (CooperationAgreementStatus) {
    CooperationAgreementStatus["DECLINED"] = "declined";
    CooperationAgreementStatus["APPROVED"] = "approved";
    CooperationAgreementStatus["PENDING"] = "pending";
})(CooperationAgreementStatus || (exports.CooperationAgreementStatus = CooperationAgreementStatus = {}));
//# sourceMappingURL=get-cooperation-agreements.types.js.map